import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Fonts } from 'components/base-ui'
import { PromotionStrategyTypeEnum } from 'graphQL/hatostore/generate/operations'
import { useTranslation } from 'react-i18next'

enum BadgeSizeEnum {
  md = 'md',
  lg = 'lg',
}

type BadgeSizeEnumStr = keyof typeof BadgeSizeEnum

interface BadgePromotionProductProps {
  promotionStrategyType: PromotionStrategyTypeEnum
  size?: BadgeSizeEnumStr
}

const BadgePromotionProduct = ({ promotionStrategyType, size = BadgeSizeEnum.md }: BadgePromotionProductProps) => {
  const { t } = useTranslation()

  const BadgeContent = useMemo(() => {
    const getBadgeBuyXGetY = (x: number) => {
      return <BadgeText>{t('badgeBuyXGetY', { buy: x, get: 1 })}</BadgeText>
    }

    const getBadgeBuyXForDiscount = (x: number) => {
      return (
        <BadgeSaverWrapper>
          <BadgeText>{t('badgeSaverPriceTitle', { buy: x })}</BadgeText>
          <BadgeSubText>{t('badgeSaverPriceSub')}</BadgeSubText>
        </BadgeSaverWrapper>
      )
    }

    switch (promotionStrategyType) {
      case PromotionStrategyTypeEnum.ManualBuy1Get1:
        return getBadgeBuyXGetY(1)
      case PromotionStrategyTypeEnum.ManualBuy2Get1:
        return getBadgeBuyXGetY(2)
      case PromotionStrategyTypeEnum.ManualBuy3Get1:
        return getBadgeBuyXGetY(3)
      case PromotionStrategyTypeEnum.ManualBuy4Get1:
        return getBadgeBuyXGetY(4)
      case PromotionStrategyTypeEnum.ManualBuy5Get1:
        return getBadgeBuyXGetY(5)
      case PromotionStrategyTypeEnum.ManualBuy6Get1:
        return getBadgeBuyXGetY(6)
      case PromotionStrategyTypeEnum.ManualBuy2ForDiscount:
        return getBadgeBuyXForDiscount(2)
      case PromotionStrategyTypeEnum.ManualBuy3ForDiscount:
        return getBadgeBuyXForDiscount(3)
      case PromotionStrategyTypeEnum.ManualBuy4ForDiscount:
        return getBadgeBuyXForDiscount(4)
      case PromotionStrategyTypeEnum.ManualBuy5ForDiscount:
        return getBadgeBuyXForDiscount(5)
      case PromotionStrategyTypeEnum.ManualBuy6ForDiscount:
        return getBadgeBuyXForDiscount(6)
      case PromotionStrategyTypeEnum.ManualBuy7ForDiscount:
        return getBadgeBuyXForDiscount(7)
      default:
        return null
    }
  }, [promotionStrategyType, t])

  return BadgeContent ? <BadgeBg size={size}>{BadgeContent}</BadgeBg> : null
}

export default BadgePromotionProduct

const BadgeBg = styled.div<{ size: BadgeSizeEnumStr }>`
  width: 38px;
  height: 38px;
  background-color: #fae700;
  border-radius: 50% 50% 0 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing['4XS']};

  ${({ size }) =>
    size === BadgeSizeEnum.lg &&
    `
      transform-origin: top left;
      transform: scale(1.5265);
    `}
`

const BadgeText = styled(Fonts.ActionBaseBold)`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1em;
`

const BadgeSubText = styled(BadgeText)`
  font-size: ${({ theme }) => theme.fontSize.xs};
`

const BadgeSaverWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing['4XS']};
`
